module.exports = __webpack_public_path__ + "img/no-avatar-event-60x60.42120b9d.svg";